import React, { type ReactNode } from 'react';

import { FloatingContext } from './Floating.context';
import { type FloatingOptions } from './Floating.types';
import { FloatingSmartTree } from './FloatingSmartTree';
import { useFloatingSetup } from './useFloatingSetup';

export const FloatingContainer = ({
    children,
    ...options
}: FloatingOptions & {
    children: ReactNode;
}) => {
    const floatingSetupValue = useFloatingSetup(options);
    return (
        <FloatingContext.Provider value={floatingSetupValue}>
            <FloatingSmartTree nodeId={floatingSetupValue.nodeId}>{children}</FloatingSmartTree>
        </FloatingContext.Provider>
    );
};

FloatingContainer.displayName = 'FloatingContainer';
